// extracted by mini-css-extract-plugin
module.exports = {"myBtn":"style_myBtn__1wdTy","myRBtn":"style_myRBtn__35PHS","inputContainer":"style_inputContainer__cwWnf","input":"style_input__20_pH","inputImg":"style_inputImg__2C3yR"};